export const CAMPO_REQUERIDO = "Este campo es requerido";
export const CAMPO_LETRAS_ESPACIOS =
  "Est campo solo acepta letras y espacios en blanco";
export const CAMPO_EMAIL = "El Email ingresado, es incorrecto";
export const CAMPO_MAX_CARACTERES = (campo, max) =>
  `El ${campo}  no debe exceder los ${max} caracteres`;
